// P1: Profile Polish - Post-onboarding nudge modal
// Uses centralized gating logic from utils/profileNudge.js
import React from "react";
import { User, X } from "lucide-react";
import { markProfileNudgeDismissed, clearProfileNudgeDismissal } from "../utils/profileNudge";

export default function ProfileCompleteNudgeModal({ open, onClose, onComplete }) {
  if (!open) return null;

  const handleDismiss = () => {
    // Record dismissal - prevents showing again for 7 days
    markProfileNudgeDismissed();
    onClose();
  };

  const handleComplete = () => {
    // Clear dismissal on completion intent (they're engaging)
    clearProfileNudgeDismissal();
    onComplete();
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) handleDismiss();
      }}
    >
      <div className="w-full max-w-md rounded-2xl bg-gray-900 border border-purple-500/30 shadow-2xl mx-4 p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2 text-purple-400">
            <User className="h-5 w-5" />
            <span className="text-sm font-medium">Complete Your Profile</span>
          </div>
          <button
            type="button"
            onClick={handleDismiss}
            className="p-2 rounded-full hover:bg-gray-800 text-gray-400 hover:text-gray-100 min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Dismiss"
            data-testid="nudge-modal-close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-white mb-2">
            Want better matches?
          </h3>
          <p className="text-gray-300 text-sm">
            Take 60 seconds to complete your profile. Users with complete profiles get 3x more matches and connections!
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-3">
          <button
            onClick={handleDismiss}
            className="flex-1 rounded-lg border border-gray-600 bg-gray-800 px-4 py-3 text-white hover:bg-gray-700 transition"
            data-testid="nudge-modal-later"
          >
            Later
          </button>
          <button
            onClick={handleComplete}
            className="flex-1 rounded-lg bg-purple-600 px-4 py-3 text-white font-semibold hover:bg-purple-700 transition"
            data-testid="nudge-modal-complete"
          >
            Complete Now
          </button>
        </div>
      </div>
    </div>
  );
}
